import { render, staticRenderFns } from "./OcorrenciasAppForm.vue?vue&type=template&id=7ff580ab&"
import script from "./OcorrenciasAppForm.vue?vue&type=script&lang=js&"
export * from "./OcorrenciasAppForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports